/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

const PanelContainer = {
  baseStyle: {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    p: "30px 15px",
    minHeight: "calc(100vh - 123px)",
    overflowX: "hidden",
    "& > *": {
      minWidth: 0,
    },
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};
